exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu{max-width:280px;min-width:280px;width:280px;overflow:scroll}.menu h1,.menu h2,.menu h3{color:#ddd;font-weight:300;padding-left:16px;font-weight:200}.menu h1{font-size:24;color:#fff}.menu h2,.menu h3{font-size:16}.menu h3{padding-top:32px}.dropdown{display:inline-block}.dropdown__content{display:none;position:absolute}.dropdown__trigger{cursor:pointer}.dropdown--active .dropdown__content{display:block;margin:8px;margin-top:0}.dropdown--active .dropdown__content *{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/containers/menu/style.scss
// module id = 277
// module chunks = 0